import script from "./endheader.vue?vue&type=script&setup=true&lang=js"
export * from "./endheader.vue?vue&type=script&setup=true&lang=js"

import "./endheader.vue?vue&type=style&index=0&id=2d4c1e47&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4c1e47"]])

export default __exports__